import React, { Component, createRef } from 'react';
import { ActionIcon, Group, Indicator, Loader, Paper, Progress, Slider, Stack, Text, Textarea, Tooltip } from '@mantine/core';
import SendIcon from '@material-ui/icons/Send';
import {setAiMessages, setAccountData, changeCurrentProperty} from '../../../../redux/action/General/generalActions';
import DeleteIcon from '@material-ui/icons/Delete';
import { connect } from 'react-redux';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CopyIcon from '../../../../neoverv/components/SVGs/copyIcon';
import { showNotification, updateNotification } from '@mantine/notifications';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import UploadIcon from '../../../../assets/images/module/general/UploadIcon.svg';
import PdfIcon from '../../../../assets/images/module/general/PdfIcon.svg';
import XlsxIcon from '../../../../assets/images/module/general/XlsxIcon.svg';
import ImgIcon from '../../../../assets/images/module/general/ImgIcon.svg';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import DocumentIcon from '../../../../assets/images/module/general/DocumentIcon.svg';
import DocumentIconBlue from '../../../../assets/images/module/general/DocumentIconBlue.svg';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import MicIcon from '@material-ui/icons/Mic';
import moment from 'moment';
import PauseIcon from '@material-ui/icons/Pause';
import InlineVoiceRecorder from '../../../../components/InlineVoiceRecorder';
import InlineAudioRecorder from '../../../../components/InlineAudioRecorder';
import { RecordOptions } from '../../../../neoverv';
import TruncatedTextHandler from '../../../../components/TruncatedTextHandler';
import Autoload from '../../../../neoverv/Autoload';
import FormatQuoteIcon from '@material-ui/icons/FormatQuote';
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import StopIcon from '@material-ui/icons/Stop';
import PrintIcon from '@material-ui/icons/Print';
import accounting from 'accounting';
import AiChatConsent from '../../../../components/AiChatConsent';
import { isAiConsentAccepted } from '../../../../helpers/aiConsent';
import { config } from '../../../../neoverv/config/Setting';
import { AI_AGENT_BASE_URL, LIVE_TRANSCRIPTION_ENABLED } from '../../../../helpers/aiAgentApi';
//'https://dev.hellohousing.de/api/bot-api'
//'http://dev.hellohousing.de:9300'
//'/api/ai-chat-api'
//'https://dev.hellohousing.de/api/bot-api'
// Shared with the messaging AI assistant so both features can't drift onto different hosts.
const baseUrl = AI_AGENT_BASE_URL;
// Values are the literals the /ask endpoint expects; the labels are display-only.
const reasoningEffortOptions = ['none', 'low', 'medium', 'high'];
const reasoningEffortLabels = {
  none: 'Keine',
  low: 'Niedrig',
  medium: 'Mittel',
  high: 'Hoch'
};
// Shown on every input control while the account still has to accept the AI
// terms, alongside the blocked cursor those controls carry.
const AI_CONSENT_REQUIRED_TOOLTIP = 'Bitte klicken Sie Akzeptieren und Fortfahren, um den KI-Assistenten zu nutzen.';
// Fixed id (not one per switch) so a second changeProperty request in the same turn updates
// the same notification instead of stacking a new one on top.
const PROPERTY_SWITCH_NOTIFICATION_ID = 'ai-property-switch';
var { loader } = Autoload.MainHelper;
class ChatApp extends Component {
  currentAudio = null;
  controller = new AbortController();
  // A changeProperty uiAction is stashed here rather than applied immediately: dispatching
  // it triggers a property-wide reload (SideBarDropDown.js reacts to any propertySelected.id
  // change), which kills this very request's still-open stream mid-flight — the model's
  // closing reply never arrives and the turn gets persisted as "Anfrage vom Benutzer
  // abgebrochen." instead. Held here until 'done' confirms the turn actually finished, then
  // applied after a short delay so the user has a moment to read that final reply first.
  pendingPropertyChange = null;
  pendingPropertyChangeTimeoutId = null;

  scrollToBottom=()=> {
    const chatBox = document.getElementById('ai-agent-chat-history-box');
    if (chatBox) {
      chatBox.scrollTop = chatBox.scrollHeight;
    }
  }

  // Used for automatic updates (streaming replies, tool-call progress) so
  // they don't yank the view down while the user has scrolled up to read
  // earlier history. Direct user actions (e.g. sending a message) should
  // keep calling scrollToBottom() unconditionally instead.
  scrollToBottomIfNearBottom=()=> {
    if (!this.state.showScrollToBottom) {
      this.scrollToBottom();
    }
  }

  constructor(props){
    super(props);
    this.fileInputRef = createRef();
    this.toolbarRef = createRef();
    this.state= { 
      messages: [], 
      input: '', 
      chatLoader: false, 
      componentLoader: true,
      selectedFile: null,
      copyHover: null, 
      hover: null,
      isAudioPlaying: false,
      audioLoader: false,
      isRecording: false,
      transcribeLoader: false,
      selectedFileData: null,
      selectedFileLocation: null,
      selectedFileUploadFailed: null,
      fileUploadInProgress: false,
      analyzingChatLoader: false,
      messageType: null,
      toolFunctionTypes: [
        "call_websearchfromhellohousinghelpcenter", 
        "call_websearch", 
        "call_gettenantdata", 
        "call_getpropertydata", 
        "call_getreceiptsdata", 
        "call_getmetersdata", 
        "call_getrentalpaymentsdata", 
        "call_getchathistory", 
        "call_getutilitybillingsdata", 
        "call_extracttenant", 
        "call_createrentalunit", 
        "call_createtenant", 
        "call_getbankaccounts", 
        "call_getbankaccounttransactions", 
        "call_codeinterpreter",
        "call_codeinterpreter_writing_code",
        "call_codeinterpreter_running_code",
        "call_codeinterpreter_generating_file",
        "call_codeinterpreter_completed",
        "call_getcostpositionsdata",
        "call_getbillingstatementsdata",
        "analyzing_data",
        "call_getallocationskeys",
        "call_getcosttypes",
        "call_createmessagedraft",
        "call_createmessagedraft_completed",
        "call_getcurrentdate",
        "call_getuserdata",
        "call_getrentalunitsdata",
        "call_getreceiptassignmentsdata",
        "call_getheatingcostsdata",
        "call_gettenantmeterreadingsforutilitybilling",
        "call_getbilligperiodsdata",
        "call_getmeterreadingsforbillingperiod",
        "call_getcostallocationsforbillingstatement",
        "call_extractreceipt",
        "call_createreceipt",
        "call_openintercomchatsupport",
        "call_createtenant_completed",
        "call_createrentalunit_completed",
        "call_createreceipt_completed",
        "call_searchintercomconversations"
      ],
      offset: 0,
      getChatLoader: false,
      hasMoreMessages: true,
      showScrollToBottom: false,
      fileDownloadLoader: null,
      deleteChatLoader: null,
      canvasLoader: false,
      metadata: null,
      toolbarPos: null,
      toolbarMessageIndex: null,
      selectedText: null,
      askCallInProgress: false,
      selectedFiles: [],
      creditUsage: null,
      testCreditsExhausted: false,
      reasoningEffort: 'medium',
      consentLoader: false,
      welcomeLoader: false,
      // Height (px) the autosize Textarea currently renders at, reported by
      // its onHeightChange. Starts at the 1-row height (see minRows={1} /
      // .ai-chat-modal-textarea-input in styles.scss: 9px padding-top/bottom
      // + 18px line-height + 1px top/bottom border = 38px) so the very first
      // render's bottomSectionHeight math below matches what actually paints.
      textareaHeight: 38
    };
  }

  componentDidMount(){
    console.log('this.props.aiChatSessionId: ', this.props.aiChatSessionId);

    if(this.props.aiChatSessionId && this.hasAiConsent()){
      this.getChatHistory(true);
    }
    // Fetched even without consent: the consent copy quotes the number of
    // KI-Einheiten included in the subscription.
    this.getCreditUsage();
    // ChatApp only ever mounts once ChatAppModal's `open` prop is already true (see its
    // render: `{open && <ChatApp .../>}`), and that only happens after Main.js has opened
    // the modal in response to the dashboard tile's prompt — so by the time this mounts,
    // initialPrompt/aiChatSessionId can already be sitting on its very first props, with no
    // prior value to transition from. componentDidUpdate's own check below would never see
    // that as a change and would silently never send it, so this needs the same check here.
    this.maybeSendInitialPrompt(null);
    this.maybeTriggerFileSelect(null);
    // const {messages} = this.props;
    setTimeout(() => {
      const chatBox = document.getElementById('ai-agent-chat-history-box');
      console.log("Scrolled to top!", chatBox);
      if (chatBox) {
        chatBox.addEventListener('scroll', this.trackScrolling);
      }
    }, 500);

    this.scrollBox = document.getElementById("ai-agent-chat-history-box");
    if (this.scrollBox) {
      this.scrollBox.addEventListener("scroll", this.handleScroll, { passive: true });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.newSessionHistoryTimeout);
    clearTimeout(this.welcomeLoaderTimeout);
    clearTimeout(this.pendingPropertyChangeTimeoutId);
    const chatBox = document.getElementById('ai-agent-chat-history-box');
    if (chatBox) {
      chatBox.removeEventListener('scroll', this.trackScrolling);
    }

    if (this.scrollBox) {
      this.scrollBox.removeEventListener("scroll", this.handleScroll);
    }
  }

  // Runs once the turn that requested a property switch has actually finished streaming
  // (called from the 'done' handler) — see the pendingPropertyChange class-field comment for
  // why this can't happen while the request is still open. The delay gives the user a moment
  // to read the model's closing reply before the property switch's own reload (triggered by
  // SideBarDropDown.js reacting to the redux change below) takes the screen away.
  applyPendingPropertyChange = () => {
    if (!this.pendingPropertyChange) return;
    const { property, path } = this.pendingPropertyChange;
    this.pendingPropertyChange = null;

    this.pendingPropertyChangeTimeoutId = setTimeout(() => {
      updateNotification({
        id: PROPERTY_SWITCH_NOTIFICATION_ID,
        loading: true,
        autoClose: false,
        withCloseButton: false,
        title: 'Immobilie wird gewechselt',
        message: 'Die Seite wird gleich neu geladen …',
      });
      try {
        localStorage.setItem('chosenProperty', property.id);
        // Belt-and-braces alongside Main.js's own persistence: guarantees the chat modal
        // comes back open and expanded (not minimized) across the reload this triggers,
        // regardless of whatever state those flags happened to be in beforehand.
        localStorage.setItem('aiChatModalOpen', 'true');
        localStorage.setItem('aiChatModalMinimized', 'false');
      } catch (e) {
        // Best-effort — a blocked/full localStorage shouldn't stop the switch.
      }
      this.props.changeCurrentProperty(property);
      this.props.history.push(path);
    }, 2500);
  };

  componentDidUpdate(prevProps){
    const hadConsent = this.hasAiConsent(prevProps);
    const hasConsent = this.hasAiConsent();

    if(!hadConsent && hasConsent && !this.props.aiChatSessionId){
      this.showWelcomeLoader();
    }

    if(prevProps.aiChatSessionId === null && this.props.aiChatSessionId && hasConsent){
      this.loadHistoryForNewSession();
    }

    // The active thread was switched to a *different* existing one (both old and new ids
    // are real sessions — the null-to-real case above is the brand-new-session path).
    // getChatHistory only ever prepends onto whatever's already in state.messages (it's
    // built for "load older messages" pagination), so without resetting first, the new
    // thread's messages would splice onto the old thread's stale ones instead of
    // replacing them.
    if(prevProps.aiChatSessionId && this.props.aiChatSessionId && prevProps.aiChatSessionId !== this.props.aiChatSessionId && hasConsent){
      // showScrollToBottom is scroll-position state from the *previous* thread's message
      // box — it only gets recomputed on a scroll event, so without resetting it here it
      // stays stuck at whatever it was (e.g. true, from having scrolled up) even when the
      // newly opened thread has no messages to scroll through at all.
      this.setState({messages: [], offset: 0, hasMoreMessages: true, showScrollToBottom: false}, () => this.getChatHistory(true));
    }

    // Consent was just given (or arrived with a refreshed account) — pull the
    // history that was withheld while the consent screen was up.
    if(!hadConsent && hasConsent && this.props.aiChatSessionId){
      this.getChatHistory(true);
    }

    // A prompt handed off from the AI dashboard tile — see maybeSendInitialPrompt.
    this.maybeSendInitialPrompt(prevProps);
    this.maybeTriggerFileSelect(prevProps);
    // const {messages} = this.props;
    // if(prevProps.messages?.length !== messages?.length){
    //   this.setState({messages, componentLoader: false});
    // }
  }

  // The account must accept the AI terms once
  // (account.consents.aiConsentAcceptedOn) before the assistant can be used.
  hasAiConsent = (props = this.props) => isAiConsentAccepted(props.accountData);

  // A prompt handed off from the AI dashboard tile, prefilled and sent exactly like a
  // manual send() once every prerequisite is actually in place. `prevProps` is null when
  // called from componentDidMount (there's nothing to have transitioned from — ChatApp can
  // mount with initialPrompt already set, see componentDidMount) and otherwise behaves like
  // an ordinary prop-transition check. Matched by id rather than plain presence — see
  // setAiChatPendingPrompt for why this slice can't just be compared by truthiness.
  maybeSendInitialPrompt = (prevProps) => {
    const hasConsent = this.hasAiConsent();
    const hadConsent = prevProps ? this.hasAiConsent(prevProps) : false;
    const prevInitialPromptId = prevProps?.initialPrompt?.id;
    const prevAiChatSessionId = prevProps?.aiChatSessionId;
    if(this.props.initialPrompt?.id && hasConsent && this.props.aiChatSessionId &&
      (this.props.initialPrompt.id !== prevInitialPromptId || !hadConsent || !prevAiChatSessionId)){
      this.setState({input: this.props.initialPrompt.text}, () => {
        this.send();
        this.props.onInitialPromptConsumed?.();
      });
    }
  };

  // The dashboard tile's "Datei anhängen" entry — same handoff shape as maybeSendInitialPrompt
  // (see there for the mount-vs-update and id-matching reasoning) but opens this thread's
  // file picker instead of sending anything.
  maybeTriggerFileSelect = (prevProps) => {
    const hasConsent = this.hasAiConsent();
    const hadConsent = prevProps ? this.hasAiConsent(prevProps) : false;
    const prevFileSelectTriggerId = prevProps?.fileSelectTrigger?.id;
    const prevAiChatSessionId = prevProps?.aiChatSessionId;
    if(this.props.fileSelectTrigger?.id && hasConsent && this.props.aiChatSessionId &&
      (this.props.fileSelectTrigger.id !== prevFileSelectTriggerId || !hadConsent || !prevAiChatSessionId)){
      this.triggerFileSelect();
      this.props.onFileSelectTriggerConsumed?.();
    }
  };

  // Stamps aiConsentAcceptedOn via the generic consents endpoint (the old
  // single-purpose ai-consent endpoint was retired), deriving the account
  // from the auth token.
  acceptAiConsent = () => {
    this.setState({consentLoader: true});
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.api_base_url + config.accountConsents,
      'PATCH',
      { consents: ['AIConsent'] },
      null,
      false,
      true,
      false,
      this,
      'handle_post_ai_consent',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_post_ai_consent(response){
    if(response.status && response.statuscode >= 200 && response.statuscode < 300){
      // Re-read the account rather than trusting the POST body: the consent
      // screen stays up until accountData actually carries the new timestamp.
      this.getAccountById();
      return;
    }
    this.setState({consentLoader: false});
  }

  getAccountById = () => {
    const {accountData, profileData} = this.props;
    const accountId = accountData?.accountId || this.props.accountId || profileData?.accountId;
    if(!accountId){
      this.setState({consentLoader: false});
      return;
    }
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + accountId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_account_by_id',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_get_account_by_id(response){
    const {accountData, setAccountData, onConsentAccepted} = this.props;
    this.setState({consentLoader: false});
    if(response.status && response.statuscode === 200){
      const updatedAccountData = {
        ...accountData,
        ...(response.result || {})
      };
      setAccountData(updatedAccountData);
      // The chat has no session while consent is pending — creating one also
      // creates its document folder — so the owner of that session is told to
      // create it now rather than only on its next prop diff.
      if(isAiConsentAccepted(updatedAccountData) && onConsentAccepted){
        onConsentAccepted(updatedAccountData);
      }
    }
  }

  // A session id has just arrived — right after consent it belongs to a
  // session created seconds ago. Loaded as a first chat load (the session has
  // no history in state yet), and retried a couple of times while it comes
  // back empty: the assistant's welcome message is written server-side as the
  // session is created, so a GET issued immediately after can still miss it.
  // Without this the greeting only showed after closing and reopening the
  // chat, which remounts and runs the first load again.
  loadHistoryForNewSession = async (attempt = 0) => {
    if(attempt === 0){
      this.showWelcomeLoader();
    }
    await this.getChatHistory(true);
    if(this.state.messages.length === 0 && attempt < 2){
      this.newSessionHistoryTimeout = setTimeout(()=> this.loadHistoryForNewSession(attempt + 1), 1500);
      return;
    }
    this.hideWelcomeLoader();
  }

  // Dots in place of the first message while the session is created and its
  // greeting is fetched, so the chat doesn't sit empty. The timeout is a
  // safety net: if the session call never comes back there is nothing left to
  // switch the loader off, and a spinner that never stops is worse than none.
  showWelcomeLoader = () => {
    clearTimeout(this.welcomeLoaderTimeout);
    this.welcomeLoaderTimeout = setTimeout(()=> this.setState({welcomeLoader: false}), 20000);
    this.setState({welcomeLoader: true});
  }

  hideWelcomeLoader = () => {
    clearTimeout(this.welcomeLoaderTimeout);
    this.setState({welcomeLoader: false});
  }

  handleScroll = () => {
    const chatBox = document.getElementById('ai-agent-chat-history-box');
    const distanceFromBottom = chatBox ? chatBox.scrollHeight - chatBox.scrollTop - chatBox.clientHeight : 0;
    this.setState({ toolbarPos: null, toolbarMessageIndex: null, showScrollToBottom: distanceFromBottom > 150 });
  };

  trackScrolling = () => {
    const el = document.getElementById('ai-agent-chat-history-box');
    const { getChatLoader, hasMoreMessages } = this.state;
    if (el && el.scrollTop === 0 && !getChatLoader && hasMoreMessages) {
      this.loadMoreMessages();
    }
  };

  triggerFileSelect = () => {
    if(!this.hasAiConsent()){
      return;
    }
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  // handleFileChange = async (event) => {
  //   const file = event.target.files?.[0];
  //   if (file) {
  //     let fileData = await this.handleUploadDocument(file);
  //     this.setState({ selectedFile: file, selectedFileData: fileData });
  //   }
  // };

  // handleFileChange = async (event) => {
  //   let files = event.target.files;
  //   if(files && files.length > 0){
  //     files = files.map(async (f)=> {
  //       let fileData = await this.handleUploadDocument(f);
  //       return {file: f, fileData};
  //     });

  //     this.setState({ selectedFiles: files });
  //   }
  // };

  handleFileChange = async (event) => {
  if(!this.hasAiConsent()){
    return;
  }
  const {selectedFiles} = this.state;
  // Get the FileList from the input event
  const files = event.target.files;

  if (files && files.length > 0) {
    // Create an array of promises. Each promise resolves
    // with the file and its uploaded data.
    const fileUploadPromises = Array.from(files).map(async (f) => {
      const fileData = await this.handleUploadDocument(f);
      return { file: f, fileData };
    });

    try {
      // Wait for ALL the file upload promises to resolve
      const uploadedFiles = await Promise.all(fileUploadPromises);

      // Now that you have the actual data, set the state
      if(selectedFiles && selectedFiles.length > 0){
        this.setState({ selectedFiles: [...selectedFiles, ...uploadedFiles] });
      }else{
        this.setState({ selectedFiles: uploadedFiles });
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      // Handle potential errors during upload here
    }
  }
};

  deleteChatHistory=async(id, chatData)=>{
    const {profileData, aiChatSessionId} = this.props;
    let {messages} = this.state;
    this.setState({deleteChatLoader: id});
    const res = await fetch(`${baseUrl}/history`, 
      {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: profileData?.id,
          chatId: id,
          documentId: chatData?.attachmentFileId,
          encryptedToken: this.props.profileData?.auth?.encryptedToken, // send as-is (don't URL encode)
          sessionId: aiChatSessionId
        }),
    });
    const { message } = await res.json();
    if(message === 'Success'){
      messages = messages.filter((item)=> item.id !== id);
      this.setState({messages},()=> this.props.updateMessages(messages));
    }
    this.setState({deleteChatLoader: null});
  }

  updateChatHistory=async(id, updatedMessage=null)=>{
    const {profileData} = this.props;
    let {messages} = this.state;
    let payload = {
      ...updatedMessage,
      id,
      userId: profileData?.id
    };
    console.log('updateChatHistory', payload);
    const res = await fetch(`${baseUrl}/history?userId=${profileData?.id}&chatId=${id}&encryptedToken=${encodeURIComponent(profileData?.auth?.encryptedToken)}`,
      {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' }
    });
    const { message } = await res.json();
    if(message === 'Success'){
      messages = messages.map((item)=> {
        if(item.id === id){
          return {...item, ...updatedMessage};
        }
        return item;
      });
      this.setState({messages}, ()=> this.props.updateMessages(messages));
    }
  }

  getChatHistoryByMessageContainerId = async (messageContainerId=null, feedback=null) => {
    const {profileData, aiChatSessionId} = this.props;
    const res = await fetch(`${baseUrl}/history?userId=${profileData?.id}&sessionId=${aiChatSessionId}&messageContainerId=${messageContainerId}&encryptedToken=${encodeURIComponent(profileData?.auth?.encryptedToken)}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    const { history } = await res.json();
    console.log('getChatHistoryByMessageContainerId: ', history);
    if(feedback === 'GOOD'){
      await this.postFineTuningDataSets(history, messageContainerId);
    }else if(feedback === 'BAD'){
      this.deleteFineTuningDataSet(messageContainerId);
    }
    await Promise.all(
      history.map(async (h) => {
        await this.updateChatHistory(h?.id, {feedback})
        return h;
      })
    );
    showNotification({
      message: 'Vielen Dank für Ihr Feedback!',
      icon: <img src={GreenTick} alt='green-tick'/>
    })
  }

  postFineTuningDataSets = async (history, messageContainerId) => {
    const {profileData} = this.props;
    const messages = history.map((ht)=> (ht?.tool_calls ? {
      "role": ht?.role,
      "tool_calls": ht?.tool_calls
    }
    : {
      "role": ht?.role,
      "content": ht?.message
    }));

    const res = await fetch(`${baseUrl}/fineTuneDataSets`, 
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId: profileData?.id,
        messages,
        messageContainerId
      })
    });
    const { response } = await res.json();
    console.log('postFineTuningDataSets: ', response);
  }

  deleteFineTuningDataSet = async (messageContainerId) => {
    const {profileData} = this.props;
    await fetch(`${baseUrl}/fineTuneDataSets`, 
      {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          messageContainerId,
          userId: profileData?.id
        }),
    });
  }

  send = async () => {
    // Hard stop: no /ask call may run before the account accepted the AI terms.
    if(!this.hasAiConsent()){
      return;
    }
    if(this.state.testCreditsExhausted){
      this.showCreditsExhaustedNotification();
      return;
    }
    const { messages, input, selectedFileData, selectedFile, metadata, selectedFiles, reasoningEffort } = this.state;
    this.controller = new AbortController();
    const newMessages = [...messages, { type: 'user', text: input, attachmentFileName: selectedFileData?.name, attachmentFileId: selectedFileData?.id, metadata, attachmentFileIds: selectedFiles.length > 0 ? selectedFiles.map((sf)=> sf.fileData.id) : [], attachmentFileNames: selectedFiles.length > 0 ? selectedFiles.map((sf)=> sf.file.name) : [] }];
    this.setState({ messages: newMessages, input: '', chatLoader: true, selectedFile: null, metadata: null, askCallInProgress: true, selectedFiles: [] },()=> {
      this.scrollToBottom();
      this.props.updateMessages(newMessages);
    });
    // The backend derives this thread's title from its first message (sessionTitleService.js)
    // fire-and-forget, in parallel with the /ask response itself — there's no single point in
    // this stream where it's guaranteed to have landed yet. Lets the parent (which owns the
    // sidebar's thread list) go pick it up once it has, instead of it staying "Neue Unterhaltung"
    // until something unrelated happens to refetch the list.
    this.props.onMessageSent?.();
    try {
      const formData = new FormData();
      formData.append('prompt', input);
      formData.append('encryptedToken', this.props.profileData?.auth?.encryptedToken);
      formData.append('accountId', this.props.accountId);
      formData.append('propertyId', this.props.propertyId);
      formData.append('userId', this.props.profileData?.id);
      selectedFiles.length > 0 && formData.append('filesData', JSON.stringify(selectedFiles.map((sf)=> sf.fileData)));
      formData.append('sessionId', this.props.aiChatSessionId);
      formData.append('metadata', JSON.stringify(metadata));
      formData.append('userEmail', this.props.profileData?.email);
      formData.append('reasoningEffort', reasoningEffort);
      
      const res = await fetch(`${baseUrl}/ask`, 
      {
        method: 'POST',
        body: formData,
        signal: this.controller.signal
      });

      const reader = res.body.getReader();
      const decoder = new TextDecoder('utf-8');
      
      let lineBuffer = '';
      let streamedText = '';
      let htmlStreamBuffer = '';
      let isTableStreaming = false; 

      let assistantMessageId = null;
      let firstMessageId = null;
      
      this.setState(prevState => ({
        messages: [...prevState.messages, { type: 'assistant', text: '', id: null }]
      }));

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        
        lineBuffer += decoder.decode(value, { stream: true });
        const lines = lineBuffer.split('\n');
        lineBuffer = lines.pop();

        for (const line of lines) {
          if (!line.trim()) continue;
          const data = JSON.parse(line);
          
          if (data.type === 'stream') {
            if (!isTableStreaming && data.delta.includes('<table')) {
              isTableStreaming = true;
            }
            if (isTableStreaming && data.delta.includes('</table>')) {
              isTableStreaming = false;
            }

            if (isTableStreaming) {
              htmlStreamBuffer += data.delta;
              const lastRowEndIndex = htmlStreamBuffer.lastIndexOf('</tr>');
              if (lastRowEndIndex !== -1) {
                const completeRowsHtml = htmlStreamBuffer.substring(0, lastRowEndIndex + 5);
                htmlStreamBuffer = htmlStreamBuffer.substring(lastRowEndIndex + 5);
                streamedText += completeRowsHtml;
              }
            } else {
              streamedText += data.delta;
            }
            
            this.setState(prevState => ({
              messages: prevState.messages.map(m => 
                (m.type === 'assistant' && m.id === null) ? { ...m, text: streamedText } : m
              ),
              analyzingChatLoader: false // <-- THE FIX: Turn off the loader when text starts streaming.
            }), () => this.scrollToBottomIfNearBottom());
          }

          if(this.isToolsCall(data.type)) {
            streamedText += data.delta;
            const updatedMessages = [
              ...this.state.messages.filter(m => m?.id !== null),
              { type: 'assistant', text: streamedText, id: assistantMessageId }
            ];
    
            this.setState({ messages: updatedMessages, chatLoader: false, analyzingChatLoader: true, messageType: data.type }, () => {
              this.scrollToBottomIfNearBottom();
              this.props.updateMessages(updatedMessages);
            });
          }

          if(data.type === 'call_openintercomchatsupport'){
            window.Intercom('showNewMessage')
          }

          if(data.type === 'call_opensubscriptionmodal'){
            this.setState({testCreditsExhausted: true});
            this.showCreditsExhaustedNotification();
          }

          if((data.type === 'call_createtenant_completed' || data.type === 'call_createrentalunit_completed') && window.location.href.includes('/user')){
            document.getElementById('update-tenants-data')?.click();
          }

          if(data.type === 'call_createreceipt_completed' && window.location.href.includes('/accounting/receipts')){
            document.getElementById('update-receipts-data')?.click();
          }

          if (data.type === 'uiAction') {
            try {
              // `state` is React Router location state. navigateToScreen sends none (its
              // screens take their parameters in the query string), but createMessageDraft
              // does: the messaging screens read message type, the target record and the
              // generated draft off location.state, so pushing the path alone would open an
              // empty, untyped new message.
              const { action: uiActionType, path, state } = JSON.parse(data.delta);

              if (uiActionType === 'changeProperty' && state?.property?.id) {
                // Stashed, not applied — see the class-field comment on pendingPropertyChange.
                // Applied from the 'done' handler below once this turn's stream has actually
                // finished, not from here while it's still open.
                this.pendingPropertyChange = { property: state.property, path: path || '/dashboard' };
                // The switch itself is still a few seconds and a reply away (deliberately —
                // see applyPendingPropertyChange) so without this the screen just sits there
                // with no sign anything is about to happen.
                showNotification({
                  id: PROPERTY_SWITCH_NOTIFICATION_ID,
                  loading: true,
                  autoClose: false,
                  withCloseButton: false,
                  title: 'Immobilie wird gewechselt',
                  message: `Wechsle zu „${state.property.name || state.property.propertyName || 'Immobilie'}“ …`,
                });
              } else if (path) {
                // Router state is only meaningful for navigateToScreen/createMessageDraft
                // targets — changeProperty carries no path here since it's deferred above.
                this.props.history.push(path, state || undefined);
              }
            } catch (e) {
              console.error('Failed to parse uiAction payload', e);
            }
          }

          if (data.type === 'done') {
            assistantMessageId = data.finalMessageId;
            firstMessageId = data.firstMessageId;

            let userMessage = this.state.messages.find((m)=> m.id === undefined);
            if(userMessage !== undefined){
              userMessage.id = firstMessageId;
            }
            
            const finalContent = data?.finalResponse?.content;

            // A turn can produce several files. Use the list when the server sends one —
            // the same fields a message reloaded from history carries — and the single
            // pair only from an older server. Never both: the message would show the
            // first file twice.
            const attachments = data?.attachmentFileIds?.length > 0
              ? { attachmentFileIds: data.attachmentFileIds, attachmentFileNames: data.attachmentFileNames }
              : { attachmentFileId: data?.attachmentFileId, attachmentFileName: data?.attachmentFileName };

            const finalMessages = [
              ...this.state.messages.filter(m => !(m.type === 'assistant' && m.id === null)),
              { type: 'assistant', text: finalContent, id: assistantMessageId, ...attachments, messageContainerId: firstMessageId, metadata: data?.receiptIds ? { receiptIds: data?.receiptIds, receiptNames: data?.receiptNames } : data?.receiptId ? { receiptId: data?.receiptId } : null, usage: data?.finalResponse?.usage || null }
            ];
            
            this.setState({ messages: finalMessages, chatLoader: false, selectedFile: null, analyzingChatLoader: false, messageType: data.type, selectedFileData: null, canvasLoader: false, askCallInProgress: false }, () => {
              this.scrollToBottomIfNearBottom();
              this.props.updateMessages(finalMessages);
              finalMessages.map((m, i)=> this.injectAiReply(m, i));
              this.getCreditUsage();
              this.applyPendingPropertyChange();
            });
            return;
          }
        }
      }

    } catch (e) {
      console.log('error: ', e);
      if(e.name === 'AbortError'){
        console.log('User clicked stop - Fetch aborted.');
        this.setState({ messages: [], offset: 0, chatLoader: false, analyzingChatLoader: false, messageType: null, canvasLoader: false, selectedFileData: null, selectedFile: null, askCallInProgress: false }, () => {
          this.props.updateMessages([]);
          setTimeout(() => {
            this.getChatHistory(true);
          }, 1000);
        });
      }else{
        const updateErrorMessages = [...messages, { type: 'assistant', text: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.' }];
        this.setState({ messages: updateErrorMessages, chatLoader: false, selectedFileData: null, selectedFile: null, canvasLoader: false, askCallInProgress: false },()=> {
          this.scrollToBottomIfNearBottom();
          this.props.updateMessages(updateErrorMessages);
        });
      }
      this.setState({ askCallInProgress: false });
    }
  };

  // send = async () => {
  //   const { messages, input, selectedFileData, selectedFile, metadata } = this.state;
  //   const newMessages = [...messages, { type: 'user', text: input, attachmentFileName: selectedFileData?.name, attachmentFileId: selectedFileData?.id, metadata }];
  //   //if (!input) return;
  //   this.setState({ messages: newMessages, input: '', chatLoader: true, selectedFile: null, metadata: null, askCallInProgress: true },()=> {
  //     this.scrollToBottom();
  //     this.props.updateMessages(newMessages);
  //   });
  //   try {
  //     const formData = new FormData();
  //     formData.append('prompt', input);
  //     formData.append('encryptedToken', this.props.profileData?.auth?.encryptedToken);
  //     formData.append('accountId', this.props.accountId);
  //     formData.append('propertyId', this.props.propertyId);
  //     formData.append('userId', this.props.profileData?.id);
  //     selectedFileData && formData.append('fileData', JSON.stringify(selectedFileData));
  //     formData.append('sessionId', this.props.aiChatSessionId);
  //     formData.append('metadata', JSON.stringify(metadata));
  //     const res = await fetch(`${baseUrl}/ask`, 
  //     {
  //       method: 'POST',
  //       body: formData,
  //       signal: this.controller.signal
  //     });

  //     const reader = res.body.getReader();
  //     const decoder = new TextDecoder('utf-8');
  //     let buffer = '';

  //     let assistantMessageId = null;
  //     let firstMessageId = null;
  //     let streamedText = '';

  //     while (true) {
  //       const { done, value } = await reader.read();
  //       if (done) break;
  //       buffer += decoder.decode(value, { stream: true });

  //       const lines = buffer.split('\n');
  //       console.log('lines: ', lines);
  //       buffer = lines.pop(); // Keep incomplete chunk

  //       for (const line of lines) {
  //         if (!line.trim()) continue;
  //         const data = JSON.parse(line);
  //         console.log('lineData: ', data);
  //         // handle data here
  //         if (data.type === 'stream') {
  //           // Append streamed chunk to text and update last assistant message
  //           streamedText += data.delta;
  //           console.log('streamedText: ', streamedText);
  //           const updatedMessages = [
  //             ...this.state.messages.filter(m => m?.id !== null),
  //             { type: 'assistant', text: streamedText, id: assistantMessageId }
  //           ];
    
  //           this.setState({ messages: updatedMessages, chatLoader: false, analyzingChatLoader: false, messageType: data.type, canvasLoader: this.state.canvasLoader ? true : data.delta === 'canvas' }, () => {
  //             this.scrollToBottom();
  //             this.props.updateMessages(updatedMessages);
  //           });
  //         }

  //         if(this.isToolsCall(data.type)) {
  //           // Append streamed chunk to text and update last assistant message
  //           streamedText += data.delta;
  //           console.log('streamedText: ', streamedText);
  //           const updatedMessages = [
  //             ...this.state.messages.filter(m => m?.id !== null),
  //             { type: 'assistant', text: streamedText, id: assistantMessageId }
  //           ];
    
  //           this.setState({ messages: updatedMessages, chatLoader: false, analyzingChatLoader: true, messageType: data.type }, () => {
  //             this.scrollToBottom();
  //             this.props.updateMessages(updatedMessages);
  //           });
  //         }

  //         if(data.type === 'call_openintercomchatsupport'){
  //           window.Intercom('showNewMessage')
  //         }
    
  //         if (data.type === 'done') {
  //           // Streaming done — update with final reply and message ids
  //           assistantMessageId = data.finalMessageId;
  //           firstMessageId = data.firstMessageId;
  //           let userMessage = this.state.messages.find((m)=> m.id === undefined);
  //           if(userMessage !== undefined){
  //             userMessage.id = firstMessageId;
  //           }
  //           console.log('beforeUpdate: ', this.state.messages);
  //           const finalMessages = [
  //             ...this.state.messages.filter(m => m?.id !== null && m?.id !== undefined),
  //             // userMessage,
  //             { type: 'assistant', text: data?.finalResponse?.content, id: assistantMessageId, attachmentFileId: data?.attachmentFileId, attachmentFileName: data?.attachmentFileName, messageContainerId: firstMessageId }
  //           ];
  //           console.log('afterUpdate: ', this.state.messages);
  //           this.setState({ messages: finalMessages, chatLoader: false, selectedFile: null, analyzingChatLoader: false, messageType: data.type, selectedFileData: null, canvasLoader: false, askCallInProgress: false }, () => {
  //             this.scrollToBottom();
  //             this.props.updateMessages(finalMessages);
  //             finalMessages.map((m, i)=> this.injectAiReply(m, i));
  //           });
  //         }
  //       }
  //     }

  //     // const { reply, firstMessageId, finalMessageId } = await res.json();
  //     // console.log('reply: ', reply);
  //     // const updatedMessages = [...messages, { type: this.props.profileData?.firstName, text: input, id: firstMessageId, attachment: selectedFile?.name }, { type: 'hellohousing KI', text: reply, id: finalMessageId }];
  //     // this.setState({ messages: updatedMessages, chatLoader: false },()=> {
  //     //   this.scrollToBottom();
  //     //   this.props.updateMessages(updatedMessages);
  //     // });
  //   } catch (e) {
  //     console.log('error: ', e);
  //     if(e.name === 'AbortError'){
  //       if(this.props.aiChatSessionId){
  //         this.setState({offset: 0, messages: [], chatLoader: false, selectedFileData: null, selectedFile: null, canvasLoader: false, askCallInProgress: false}, ()=> setTimeout(() => {
  //           this.getChatHistory(true);
  //           this.scrollToBottom();
  //         }, 600));
  //       }
  //     }else{
  //       const updateErrorMessages = [...messages, { type: 'assistant', text: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.' }];
  //       this.setState({ messages: updateErrorMessages, chatLoader: false, selectedFileData: null, selectedFile: null, canvasLoader: false, askCallInProgress: false },()=> {
  //         this.scrollToBottom();
  //         this.props.updateMessages(updateErrorMessages);
  //       });
  //     }
  //   }
  // };

  isToolsCall=(type)=>{
    const {toolFunctionTypes} = this.state;
    return toolFunctionTypes.find((value)=> value === type) !== undefined ? true : false;
  }

  showCreditsExhaustedNotification = () => {
    showNotification({
      message: 'Das KI-Guthaben Ihres Test-Abonnements ist aufgebraucht. Nach dem Start eines Bezahl-Abonnements stehen Ihnen flexibel weiteres KI-Guthaben zur Verfügung.',
      icon: <img src={RedCross} alt='red-cross'/>
    });
  }

  // InlineVoiceRecorder's onError: the live-transcription socket was rejected by the credit
  // gate (or errored/dropped) before or during a recording — see liveTranscriptionService.js.
  // Unlike /ask's credit-gate rejection, there's no chat turn to drop the message into here,
  // so it surfaces as a toast using the backend's own message text rather than a hardcoded
  // one, since that text already differs by case (testing-subscription vs. generally
  // exhausted — see creditGateService.js's requiresSubscriptionUpgrade).
  handleVoiceRecorderError = (detail) => {
    if (detail?.requiresSubscriptionUpgrade) {
      this.setState({ testCreditsExhausted: true });
    }
    showNotification({
      message: detail?.error || 'Die Aufnahme konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
      icon: <img src={RedCross} alt='red-cross'/>
    });
  }

  handleKeyDown = (e) => {
    if(!this.hasAiConsent()){
      e.preventDefault();
      return;
    }
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // prevent new line
      this.send();
    }
  };

  stopTTS=()=> {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
    }
  }

  playTTS = async(text, id) => {
    this.stopTTS();
    this.setState({audioLoader: id}, async ()=>{
      const response = await fetch(`${baseUrl}/speech`, 
      {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text }),
      });
    
      const blob = await response.blob();
      const audioUrl = URL.createObjectURL(blob);
      this.currentAudio = new Audio(audioUrl);
      // Handle play, pause, end
      this.currentAudio.onplay = () => this.setState({isAudioPlaying: id});
      this.currentAudio.onpause = () => this.setState({isAudioPlaying: false});
      this.currentAudio.onended = () => this.setState({isAudioPlaying: false});
      this.setState({audioLoader: false},()=> this.currentAudio.play());
    });
  }
  


  handlePaste = (event) => {
    if(!this.hasAiConsent()){
      event.preventDefault();
      return;
    }
    const items = event.clipboardData.items;

    for (const item of items) {
      if (item.kind === 'file') {
        const file = item.getAsFile();
        console.log('Pasted file:', file);

        // Prevent the default paste behavior if needed
        event.preventDefault();

        // Handle the file (e.g., upload, preview, etc.)
        if (file) {
          this.setState({ selectedFile: file });
        }
      }
    }
  };
  
  returnFileIcon=(type)=>{
    console.log('returnFileIcon: ', type);
    switch (type) {
      case 'image/jpeg':
        return ImgIcon;
      case 'application/pdf':
        return PdfIcon;
      case 'image/png':
        return ImgIcon;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return XlsxIcon;
      default:
        return DocumentIconBlue;
    }
  }

  loadMoreMessages = async () => {
    const chatBox = document.getElementById('ai-agent-chat-history-box');
    if (!chatBox) return;

    const { getChatLoader, hasMoreMessages } = this.state;
    if (getChatLoader || !hasMoreMessages) return;

    const previousScrollHeight = chatBox.scrollHeight;
    const previousScrollTop = chatBox.scrollTop;

    // Fetch messages (prepends to list)
    await this.getChatHistory();

    // After rendering new messages, re-anchor the scroll position so the
    // messages the user was already reading don't jump under them.
    requestAnimationFrame(() => {
      const newScrollHeight = chatBox.scrollHeight;
      chatBox.scrollTop = newScrollHeight - previousScrollHeight + previousScrollTop;
    });
  };

  // Old flow's transcription: unlike InlineVoiceRecorder's live captions, this only has text
  // once the whole clip has uploaded and come back — so it sends immediately on success too
  // (same "stop = I'm done" behavior as the live path), rather than making the user click
  // send a second time.
  uploadAudio = async (file) => {
    if (!file || !this.hasAiConsent()) return;
    this.setState({transcribeLoader: true});
    const formData = new FormData();
    formData.append('file', file);
    formData.append('accountId', this.props.accountId);
    formData.append('userId', this.props.profileData?.id);
    formData.append('propertyId', this.props.propertyId);
    formData.append('encryptedToken', this.props.profileData?.auth?.encryptedToken);

    try {
      const res = await fetch(`${baseUrl}/transcribe`, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) {
        this.handleVoiceRecorderError(data);
        return;
      }
      const trimmed = (data.text || '').trim();
      this.setState({ input: data.text || '' }, () => {
        if (trimmed) this.send();
      });
    } catch (err) {
      console.error(err);
      this.handleVoiceRecorderError({ error: 'Die Aufnahme konnte nicht transkribiert werden. Bitte versuchen Sie es erneut.' });
    } finally {
      this.setState({transcribeLoader: false});
    }
  };

  handleUploadDocument = async (file) =>
    new Promise((resolve, reject) => {
      const {propertySelected, aiChatSessionFolderId, aiChatSessionId, accountData} = this.props;
      this.setState({fileUploadInProgress: true});
      const formData = new FormData();
      formData.append('file', file);
      // accountId comes from accountData, not propertySelected, for the same reason as
      // ChatAppModal's createSessionFolder: this can run before the account has any
      // property, when propertySelected is still {} and .accountId is undefined.
      formData.append('accountId', accountData?.accountId);
      propertySelected?.id && formData.append('propertyId', propertySelected.id);
      formData.append('name', file.name);
      formData.append('isDirectory', false);
      formData.append('isReadOnly', false);
      formData.append('isShared', false);
      formData.append('fileType', 'ChatBotDocument');
      formData.append('parentDirectoryId', aiChatSessionFolderId);
      //formData.append('referencedObjectId', id);

      fetch(Autoload.Setting.document_api_base_url + 'documents', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: Autoload.Utils.getAuthToken()
        }
      })
        .then((data) => data.json())
        .then((response) => 
        this.setState({
          //selectedFileData: response?.result,
          //selectedFileLocation: response2?.result?.fileLocation,
          fileUploadInProgress: false,
          selectedFileUploadFailed: false
        }, ()=> resolve(response?.result))
        // fetch(Autoload.Setting.document_api_base_url + 'documents/' + response?.result?.id, //+ '/download', //resolve(result.data.url)
        // {
        //   method: 'GET',
        //   headers: {
        //     'Authorization': Autoload.Utils.getAuthToken()
        //   }
        // })
        // .then(data2 => {
        //   data2.json()
        //   .then(response2 => {
        //     this.setState({
        //       selectedFileData: response2?.result,
        //       selectedFileLocation: response2?.result?.fileLocation,
        //       fileUploadInProgress: false,
        //       selectedFileUploadFailed: false
        //     }, ()=> resolve(response2?.result?.id));
        //   })
        // }).catch(()=> {
        //   this.setState({fileUploadInProgress: false, selectedFileUploadFailed: true});
        //   reject(new Error('Download failed'));
        // })
        )
        .catch((e) => {
          this.setState({fileUploadInProgress: false, selectedFileUploadFailed: true});
          reject(new Error('Upload failed'));
          console.error('handleUploadDocument: ', e);
        });
  });

  handleDocumentDelete=(callBackFunction= null, id)=>{
    const {selectedFileData} = this.state;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.document_api_base_url + 'documents/'+ (id ? id : selectedFileData?.id),
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteDocumentByIdResponse',
      {callBackFunction, id},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }
  
  handleDeleteDocumentByIdResponse(response){
    if(response.status && response.statuscode === 200){
      if(response.other.id){
        this.setState({selectedFiles: this.state.selectedFiles.filter((f)=> f.fileData.id !== response.other.id)});
      }else{
        this.setState({selectedFileData: null, selectedFile: null});
      }
      if(response.other.callBackFunction){
        response.other.callBackFunction();
      }
    }
  }
  
  // getMessageTypeStatus=(messageType)=>{
  //   switch (messageType) {
  //     case 'web_search':
  //       return 'Websuche';
  //     case 'analyzing_data':
  //       return 'Analysing';
  //     case 'get_property_data':
  //       return 'Immobiliendaten abrufen';
  //     case 'get_tenants_data':
  //       return 'Mieterdaten abrufen';
  //     case 'get_receipts_data':
  //       return 'Belegdaten abrufen';
  //     case 'get_meters_data':
  //       return 'Zählerdaten abrufen';
  //     case 'get_rental_payments_data':
  //       return 'Daten zu Mietzahlungen abrufen';
  //     case 'get_bank_accounts_data':
  //       return 'Bankkontodaten abrufen';
  //     case 'get_transactions_data':
  //       return 'Transaktionsdaten abrufen';
  //     case 'get_chat_history_data':
  //       return 'Chatverlauf abrufen';
  //     case 'get_utility_billings_data':
  //       return 'Betriebskosten-Daten erfassen';
  //     case 'extracting_tenant':
  //       return 'Extrahieren von Mieterdaten aus einer Datei';
  //     case 'creating_tenant':
  //       return 'Mieter erstellen';
  //     case 'creating_rental_unit':
  //       return 'Erstellen einer Mieteinheit';
  //     case 'web_search_from_help_center':
  //       return 'Suche im hellohousing Hilfe-Center'
  //     default:
  //       return null;
  //   }
  // }

  getMessageTypeStatus(event) {
    const statusMap = {
      // Existing Events
      call_websearchfromhellohousinghelpcenter: "Suche in der hellohousing-Hilfe läuft",
      call_websearch: "Websuche läuft",
      call_gettenantdata: "Mieterdaten werden geladen",
      call_getpropertydata: "Objektdaten werden geladen",
      call_getreceiptsdata: "Belegdaten werden geladen",
      call_getmetersdata: "Zählerdaten werden geladen",
      call_getrentalpaymentsdata: "Mietzahlungen werden geladen",
      call_getchathistory: "Chatverlauf wird geladen",
      call_getutilitybillingsdata: "Nebenkostendaten werden geladen",
      call_extracttenant: "Mieterdaten werden extrahiert",
      call_createrentalunit: "Neue Wohneinheit wird angelegt",
      call_createtenant: "Neuer Mieter wird angelegt",
      call_getbankaccounts: "Bankkonten werden geladen",
      call_getbankaccounttransactions: "Banktransaktionen werden geladen",
      call_codeinterpreter: "Datei wird generiert",
      call_codeinterpreter_writing_code: "Datei wird vorbereitet",
      call_codeinterpreter_running_code: "Datei wird erstellt",
      call_codeinterpreter_generating_file: "Datei wird generiert",
      call_codeinterpreter_completed: "Datei wurde generiert",
      call_getcostpositionsdata: "Kostenverteilung wird geladen",
      call_getbillingstatementsdata: "Betriebskostenabrechnungen werden geladen",
      
      // Newly Added Events
      call_getallocationskeys: "Verteilerschlüssel werden geladen",
      call_getcosttypes: "Kostenarten werden geladen",
      call_getcurrentdate: "Aktuelles Datum wird abgerufen",
      call_getuserdata: "Benutzerdaten werden geladen",
      call_getrentalunitsdata: "Mieteinheiten werden geladen",
      call_getreceiptassignmentsdata: "Belegzuordnungen werden geladen",
      call_getheatingcostsdata: "Heizkostendaten werden geladen",
      call_gettenantmeterreadingsforutilitybilling: "Zählerstände für die Nebenkostenabrechnung werden geladen",
      call_getbilligperiodsdata: "Abrechnungsperioden werden geladen",
      call_getmeterreadingsforbillingperiod: "Zählerstände für die Abrechnungsperiode werden geladen",
      call_getcostallocationsforbillingstatement: "Kostenumlagen für die Abrechnung werden geladen",
      call_extractreceipt: "Beleg wird analysiert",
      call_createreceipt: "Beleg wird erstellt",
      call_openintercomchatsupport: "Support-Chat wird geöffnet",
      call_searchintercomconversations: "Suche in Wissensbasis",
      call_createmessagedraft: "Nachricht wird verfasst",
      call_createmessagedraft_completed: "Nachricht wurde erstellt",

      // General Status
      analyzing_data: "Analyse"
    };
  
    return statusMap[event] || "Aktion wird ausgeführt";
  }

  // getMessageTypeStatus(event) {
  //   const statusMap = {
  //     call_websearchfromhellohousinghelpcenter: "Suche in der HelloHousing-Hilfe läuft",
  //     call_websearch: "Websuche läuft",
  //     call_gettenantdata: "Mieterdaten werden geladen",
  //     call_getpropertydata: "Objektdaten werden geladen",
  //     call_getreceiptsdata: "Belegdaten werden geladen",
  //     call_getmetersdata: "Zählerdaten werden geladen",
  //     call_getrentalpaymentsdata: "Mietzahlungen werden geladen",
  //     call_getchathistory: "Chatverlauf wird geladen",
  //     call_getutilitybillingsdata: "Nebenkostendaten werden geladen",
  //     call_extracttenant: "Mieterdaten werden extrahiert",
  //     call_createrentalunit: "Neue Wohneinheit wird angelegt",
  //     call_createtenant: "Neuer Mieter wird angelegt",
  //     call_getbankaccounts: "Bankkonten werden geladen",
  //     call_getbankaccounttransactions: "Banktransaktionen werden geladen",
  //     call_codeinterpreter: "Datei wird generiert",
  //     analyzing_data: "Analyse",
  //     call_getcostpositionsdata: "Kostenverteilung werden geladen",
  //     call_getbillingstatementsdata: "Betriebskostenabrechnung werden geladen"
  //   };
  
  //   return statusMap[event] || "Unbekanntes Ereignis";
  // }

  getTest= async () => {
    try {
      const res = await fetch(`${baseUrl}/test`, 
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
  
      const { message } = await res.json();
      console.log('getTest: ', message);  
    } catch (error) {
      console.log('getTest: error: ', error);
    }
  }
  

  getCreditUsage = async () => {
    const accountId = this.props.accountId;
    const encryptedToken = this.props.profileData?.auth?.encryptedToken;
    if(!accountId || !encryptedToken){
      return;
    }
    try {
      const res = await fetch(`${baseUrl}/creditUsage?accountId=${encodeURIComponent(accountId)}&encryptedToken=${encodeURIComponent(encryptedToken)}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await res.json();
      if(data?.error){
        console.log('getCreditUsage: error: ', data.error);
        return;
      }
      this.setState({ creditUsage: data });
      this.props.onCreditUsageChange?.(data);
    } catch (e) {
      console.log('getCreditUsage: error: ', e);
    }
  }

  getChatHistory=async(firstChatLoad=false)=>{
    const {profileData, aiChatSessionId} = this.props;
    const {offset, getChatLoader, hasMoreMessages} = this.state;
    if(!this.hasAiConsent()) return;
    if(getChatLoader) return;
    if(!firstChatLoad && !hasMoreMessages) return;
    this.setState({getChatLoader: true});

    const res = await fetch(`${baseUrl}/history?userId=${profileData?.id}&sessionId=${aiChatSessionId}&limit=${10}&offset=${offset}&encryptedToken=${encodeURIComponent(profileData?.auth?.encryptedToken)}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const { history } = await res.json();
      console.log('history: ', history);
      const {messages} = this.state;
      if(history?.length > 0){
        const newMessages = history.map((item)=> ({
            id: item.id,
            type: item.role,
            text: item.message,
            attachmentFileName: item?.attachmentFileName,
            attachmentFileId: item?.attachmentFileId,
            attachmentFileNames: item?.attachmentFileNames,
            attachmentFileIds: item?.attachmentFileIds,
            feedback: item?.feedback,
            timestamp: item.timestamp,
            metadata: item?.metadata ? JSON.parse(item?.metadata) : null,
            messageContainerId: item?.messageContainerId,
            usage: item?.usage || null
        }));
        // A message send() just added optimistically (no real id yet — see the 'done'
        // handler, which is what actually stamps one) can still be sitting in `messages`
        // when this fetch resolves, most notably right after the dashboard tile hands off a
        // prompt: that reset-and-reload and the optimistic add race each other by design (see
        // maybeSendInitialPrompt). If the backend had already persisted the turn by the time
        // this fetch ran, it comes back here too — drop the optimistic copy rather than
        // double it up.
        const dedupedMessages = messages.filter((m) =>
          !(m.id === undefined && newMessages.some((nm) => nm.type === m.type && nm.text === m.text))
        );
        const updatedMessages = [...newMessages, ...dedupedMessages];
        this.setState({messages: updatedMessages, offset: offset + history.length, hasMoreMessages: history.length === 10}, ()=> {
          if(firstChatLoad){
            this.scrollToBottom();
            // render() assigns each message's DOM id from its index in the
            // timestamp-sorted list, so mirror that sort here to match ids.
            const sortedMessages = [...updatedMessages].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
            setTimeout(() => {
              sortedMessages.map((m, i)=> this.injectAiReply(m, i));
            }, 1000);
          }else{
            // The newly prepended batch always sorts to the front of the
            // full list (it's strictly older), so its own timestamp order
            // gives the correct indices to match render()'s DOM ids.
            const sortedNewMessages = [...newMessages].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
            setTimeout(() => {
              sortedNewMessages.map((m, i)=> this.injectAiReply(m, i));
            }, 1000);
          }
        });
      }else{
        this.setState({hasMoreMessages: false});
      }
      this.setState({getChatLoader: false});
  }

  injectAiReply=(m, i)=> {
    const container = document.getElementById(`ai-chat-${m?.id}-${i}-response`);
    if(!container) return;
    container.innerHTML = m?.text;
  
    // Run scripts inside injected HTML
    const scripts = container.querySelectorAll('script');
    console.log('scripts: ', scripts);
    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script');
      if (oldScript.src) {
        newScript.src = oldScript.src;
      } else {
        // Wrap inline script in IIFE to isolate scope
        newScript.textContent = `(function() { ${oldScript.textContent} })();`;
      }
      document.body.appendChild(newScript);
    });
  }
  

  openReceipt=(receiptName)=>{
    if(!receiptName) return;
    //this.props.onMinimize && this.props.onMinimize();
    //window.location.href = `${window.location.origin}/accounting/receipts?receiptId=${receiptId}`;
    this.props.history.push(`/accounting/receipts?search=${receiptName}`);
  }

  downloadDocumentsById= async(id, name)=>{
    this.setState({fileDownloadLoader: id});

    await fetch(Autoload.Setting.document_api_base_url + 'documents/' + id + '/download',
      {
        method: 'GET',
        headers: {
          'Authorization': Autoload.Utils.getAuthToken()
        }
      })
      .then(response => {
        response.blob()
        .then(data => {
          //download progress
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          let url = window.URL.createObjectURL(data);
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
          this.setState({fileDownloadLoader: null});    
        }).catch(()=> this.setState({fileDownloadLoader: null}))
      }).catch(()=> this.setState({fileDownloadLoader: null}));
  }

  handleMouseUp = () => {
    const selection = window.getSelection();
    console.log('selection: ', selection.toString());
    if (selection.toString()) {
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      const anchorNode = range.startContainer.nodeType === 3 ? range.startContainer.parentElement : range.startContainer;
      const bubble = anchorNode?.closest('.ai-chat-bubble, .user-chat-bubble');
      const bubbleRect = bubble?.getBoundingClientRect();

      if (!bubbleRect) {
        this.setState({ toolbarPos: null, toolbarMessageIndex: null });
        return;
      }

      // toolbarPos is anchored to the chat bubble (which is position: relative),
      // not the viewport, so it stays correctly placed regardless of where the
      // draggable chat modal has been moved to on screen. toolbarMessageIndex
      // records which bubble it belongs to, since toolbarPos itself is shared
      // component state and every bubble in the list re-renders on change.
      this.setState({
        toolbarPos: {
          top: rect.top - bubbleRect.top - 40,
          left: rect.left - bubbleRect.left + rect.width / 2,
        },
        toolbarMessageIndex: bubble.dataset.messageIndex,
        selectedText: selection.toString()
      });
    } else {
      this.setState({ toolbarPos: null, toolbarMessageIndex: null });
    }
  };

  handleQuoteFromPreviousMessage=()=>{
    const {selectedText} = this.state;

    if(selectedText?.length > 0){
      let metadata = {
        targeted_reply: selectedText
      };
  
      this.setState({metadata, selectedText: null, toolbarPos: null, toolbarMessageIndex: null});
    }
  }

  printChat=(aiHtml)=>{
    const printWindow = window.open("", "", "height=600,width=800");
    printWindow.document.write(`
      <html>
        <head>
          <style>
            body { font-family: Inter, sans-serif; margin: 20px; font-size: 14px; font-weight: 400; }
            table { border-collapse: collapse; width: 100%; margin-top: 15px; }
            th, td { padding: 16px; text-align: left; }
            td { background: #F7F7FA; font-weight: 300; font-size: 14px; }
            th { color: #727293; font-weight: 400; font-size: 12px; padding-bottom: 0px; }
            p { margin: 10px 0; font-family: Inter, sans-serif; font-size: 14px; font-weight: 400; }
            span { font-family: Inter, sans-serif; font-size: 14px; font-weight: 400; }
          </style>
        </head>
        <body>
          ${aiHtml}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  }

  handleChatClick = (event) => {
    const link = event.target.closest('a');
    if (link && link.href) {
      event.preventDefault();
      window.open(link.href, '_blank', 'noopener,noreferrer');
    }
  };

  render() {
    const {width, height, minimize, profileData} = this.props;
    const {chatLoader, messages, componentLoader, selectedFile, copyHover, hover, isAudioPlaying, audioLoader, isRecording, transcribeLoader, selectedFileData, fileUploadInProgress, analyzingChatLoader, messageType, fileDownloadLoader, deleteChatLoader, canvasLoader, toolbarPos, toolbarMessageIndex, selectedText, metadata, askCallInProgress, selectedFiles, testCreditsExhausted, getChatLoader, hasMoreMessages, showScrollToBottom, reasoningEffort, consentLoader, creditUsage, welcomeLoader, textareaHeight} = this.state;
    const aiConsentGiven = this.hasAiConsent();
    console.log('messages: ', messages);
    console.log('profileData: ', this.props.profileData);
    console.log("width:", width, parseInt(width), height, `${parseInt(height) + 200}px`);
    console.log('fileUploadInProgress: ', fileUploadInProgress);
    // Your existing logic for the input area's height
    let bottomSectionHeight = metadata ? 240 : (parseInt(width) < 645 ? 175 : parseInt(width) < 1240 ? 155 : 140);

    // If a file is selected, add 50px for the file chip's height
    if (selectedFileData || selectedFiles.length > 0) {
      bottomSectionHeight += 50;
    }

    // The breakpoint constants above assume a 1-row textarea (its baseline
    // height, see the textareaHeight initial state). The autosize Textarea
    // can grow up to 3 rows (see minRows/maxRows on the Textarea below), so
    // any growth past that baseline has to be added here too, or the taller
    // box overlaps the "ai-chat-notice" disclaimer text instead of pushing
    // the message list up to make room.
    bottomSectionHeight += Math.max(0, (textareaHeight || 38) - 38);

    const chatBoxHeight = `calc(100% - ${bottomSectionHeight}px)`;
    return (
      <Stack 
      gap={8}
      style={{
        width: '100%',
        height: height,
        visibility: minimize ? 'hidden' : 'visible'
      }}>
        <div style={{ position: 'relative', width: '100%', height: chatBoxHeight }}>
        <div id='ai-agent-chat-history-box' className='ai-agent-chat-history-box' gap={0} style={{ height: '100%' }}>
          {!aiConsentGiven ?
          <AiChatConsent
          includedCredits={creditUsage?.includedCreditsAvailable === true ? creditUsage?.includedCredits : null}
          loading={consentLoader}
          onReveal={()=> this.scrollToBottomIfNearBottom()}
          onAccept={()=> this.acceptAiConsent()}/>
          :
          <>
          {messages?.length > 0 &&
          <Group justify='center' style={{width: '100%', margin: '20px 0px'}}>
            {getChatLoader ?
            <Loader size={'sm'}/>
            :
            hasMoreMessages && <span className='ai-load-more-chat-button' onClick={()=> this.loadMoreMessages()}>Mehr laden</span>
            }
          </Group>}
          {messages.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp)).map((m, i) => {
            const aiChatResponseId = `ai-chat-${m?.id}-${i}-response`;
            return (<Stack key={`ai-chat-${m?.id}-${i}`} id={`ai-chat-${m?.id}-${i}`} align={m?.type !== 'user' ? 'flex-start' : 'flex-end'}>
              {m?.metadata?.targeted_reply &&
              <Group gap={10} wrap="nowrap" className={'user-chat-bubble-meta-data'} justify={m?.type !== 'user' ? 'left' : 'right'}>
                <KeyboardReturnIcon style={{ transform: "scaleX(-1)", color: '#13135c' }} />
                <TruncatedTextHandler text={m?.metadata?.targeted_reply} className={'ask-ai-chat-meta-data-text'} maxWidth={parseInt(width) - 650} disableTooltip={false} tooltipWidth={200}/>
              </Group>}
              <Group justify={m?.type !== 'user' ? 'left' : 'right'} onMouseEnter={()=> this.setState({hover: `hover-${m?.id}-${i}`})} onMouseLeave={()=> this.setState({hover: null})}>
                <Stack gap={0} style={{marginBottom: '1rem'}} align={m?.type !== 'user' ? 'flex-start' : 'flex-end'} >
                  <p className={m?.type === 'user' ? 'user-chat-bubble' : 'ai-chat-bubble'} id={`user-chat-bubble-${m?.id}`} data-message-index={i} key={i} style={{position: 'relative'}}>
                    <span className={m?.type === 'user' ? 'user-chat-bubble-label' : 'ai-chat-bubble-label'}>{m?.type  === 'user' ? profileData?.firstName : 'hellohousing KI'}</span>
                    <br style={{marginBottom: 10}}/>
                    {(analyzingChatLoader && m?.id === null && m?.type !== 'user') ? 
                    <Group wrap="nowrap" gap={5}>
                      <span style={{color: '#5555FF'}}>{this.getMessageTypeStatus(messageType)}</span>
                      <Loader size={12} type={'dots'} color={'#5555FF'} className='mt-2'/>
                    </Group>
                    :
                    <>

                      <div 
                      style={{maxWidth: parseInt(width) - 80}} 
                      id={aiChatResponseId} 
                      suppressContentEditableWarning
                      onMouseUp={this.handleMouseUp} 
                      onClick={this.handleChatClick}
                      className={`ai-chat-response-text ${m?.type !== 'user' ? 'mt-2' : ''}`} 
                      dangerouslySetInnerHTML={{__html: m?.text}}/>

                      {toolbarPos && String(toolbarMessageIndex) === String(i) && (
                        <div
                          ref={this.toolbarRef}
                          style={{
                            position: "absolute",
                            top: toolbarPos.top - ((selectedText.length / 45) <= 1 ? 15 : ((selectedText.length / 45) * 22)),
                            left: toolbarPos.left,
                            transform: "translateX(-50%)",
                          }}
                          className="ask-ai-chat-tooltip"
                          onClick={this.handleQuoteFromPreviousMessage}
                        >
                          <Group wrap="nowrap" gap={3}>
                            <FormatQuoteIcon className='ask-ai-chat-tooltip-icon'/>
                            <span className='ask-ai-chat-tooltip-span'>{selectedText}</span>
                          </Group>
                        </div>
                      )}

                      {(canvasLoader && m?.type !== 'user' && !m?.id) && 
                      <Group wrap="nowrap" gap={5}>
                        <span style={{color: '#5555FF'}}>{'Grafik erstellen'}</span>
                        <Loader size={12} type={'dots'} color={'#5555FF'} className='mt-2'/>
                      </Group>}
                    </>
                    }
                    {m?.attachmentFileId &&
                    <Group gap={5} style={{cursor: 'pointer'}} wrap="nowrap" className='mt-2' onClick={()=> this.downloadDocumentsById(m?.attachmentFileId, m?.attachmentFileName)}>
                      {fileDownloadLoader === m?.attachmentFileId ?
                      <Loader size={'xs'}/>
                      :
                      <AttachFileIcon
                      style={{
                        cursor: 'pointer',
                        color: '#5555FF',
                        fontSize: '16px'
                      }}/>}
                      <span className='ai-chat-attached-file-name'>{m?.attachmentFileName}</span>
                    </Group>}
                    {m?.attachmentFileIds?.length > 0 &&
                    <Stack gap={5} style={{overflowY: 'scroll'}}>
                      {m?.attachmentFileIds.map((attachmentFileId, index)=> 
                      <Group gap={5} style={{cursor: 'pointer'}} wrap="nowrap" className='mt-2' onClick={()=> this.downloadDocumentsById(attachmentFileId, m?.attachmentFileNames[index])} key={`attachment-file-${attachmentFileId}-${index}`}>
                        {fileDownloadLoader === attachmentFileId ?
                        <Loader size={'xs'}/>
                        :
                        <AttachFileIcon
                        style={{
                          cursor: 'pointer',
                          color: '#5555FF',
                          fontSize: '16px'
                        }}/>}
                        <span className='ai-chat-attached-file-name'>{m?.attachmentFileNames[index]}</span>
                      </Group>)}
                    </Stack>}
                    {m?.metadata?.receiptIds?.length > 0 ?
                    <Stack className='mt-2' style={{overflowX: 'scroll'}}>
                      {m?.metadata?.receiptIds.map((receiptId, index)=>
                      <Group gap={5} style={{cursor: 'pointer'}} wrap="nowrap" onClick={()=> this.openReceipt(m?.metadata?.receiptNames?.[index])} key={`receipt-${receiptId}-${index}`}>
                        <AttachFileIcon
                        style={{
                          cursor: 'pointer',
                          color: '#5555FF',
                          fontSize: '16px'
                        }}/>
                        <span className='ai-chat-attached-file-name intercom-chat-link'>{m?.metadata?.receiptNames?.[index] ? `Beleg ${m?.metadata?.receiptNames[index]} anzeigen` : (m?.metadata?.receiptIds?.length > 1 ? `Beleg ${index + 1} öffnen` : 'Beleg öffnen')}</span>
                      </Group>)}
                    </Stack>
                    :
                    m?.metadata?.receiptId &&
                    <Group gap={5} style={{cursor: 'pointer'}} wrap="nowrap" className='mt-2' onClick={()=> this.openReceipt(m?.metadata?.receiptId)}>
                      <AttachFileIcon
                      style={{
                        cursor: 'pointer',
                        color: '#5555FF',
                        fontSize: '16px'
                      }}/>
                      <span className='ai-chat-attached-file-name intercom-chat-link'>Beleg öffnen</span>
                    </Group>}
                  </p>
                  {m?.id &&
                  <Group justify="space-between" style={{minWidth: '200px'}} wrap="nowrap" className={m?.type === 'user' ? 'user-chat-bubble-action-buttons' : 'ai-chat-bubble-action-buttons'}>
                    <Group gap={6} wrap="nowrap" style={{visibility: hover === `hover-${m?.id}-${i}` ? 'visible' : 'hidden'}}
                    >
                      {deleteChatLoader === m?.id ?
                      <Loader size={'xs'}/>
                      :
                      <Tooltip label={'Entfernen'} zIndex={9999}>
                        <DeleteIcon className='delete-ai-chat-history' onClick={()=> this.deleteChatHistory(m?.id, m)}/>
                      </Tooltip>}
                      <Tooltip label={'Kopie'} zIndex={9999}>
                        <div 
                        style={{cursor: 'pointer'}}
                        onMouseEnter={()=> this.setState({copyHover: `copyHover-${m?.id}-${i}`})} 
                        onMouseLeave={()=> this.setState({copyHover: null})}
                        onClick={()=> {
                          //navigator.clipboard.writeText(m?.text.replace(/<[^>]*>/g, ''));
                          const plainText = m?.text
                          ?.replace(/<[^>]+>/g, ' ')      // Replace tags with a space (preserve some spacing)
                          ?.replace(/\s{2,}/g, ' ')       // Collapse multiple spaces
                          ?.replace(/\n\s*\n/g, '\n')     // Collapse multiple newlines
                          ?.replace(/\s*\n\s*/g, '\n')    // Trim space around newlines
                          ?.trim();

                          navigator.clipboard.writeText(plainText);

                          showNotification({
                            message: 'Inhalte kopiert',
                            icon: <img src={GreenTick} alt='green-tick'/>,
                          })
                        }}>
                          <CopyIcon 
                          fill={copyHover === `copyHover-${m?.id}-${i}` ? '#5555FF' : '#727293'} 
                          width='14px' 
                          height='14px'/>
                        </div>
                      </Tooltip>
                      
                      {m?.type !== 'user' &&
                      <>
                      <Tooltip label={'Gute Antwort'} zIndex={9999}>
                        <ThumbUpIcon className={m?.feedback === 'GOOD' ? 'thumbs-up-ai-chat-history-active' : 'thumbs-up-ai-chat-history'} onClick={()=> this.getChatHistoryByMessageContainerId(m?.messageContainerId, 'GOOD')}/>
                      </Tooltip>
                      <Tooltip label={'Schlechte Antwort'} zIndex={9999}>
                        <ThumbDownIcon className={m?.feedback === 'BAD' ? 'thumbs-down-ai-chat-history-active' : 'thumbs-down-ai-chat-history'} onClick={()=> this.getChatHistoryByMessageContainerId(m?.messageContainerId, 'BAD')}/>
                      </Tooltip>
                      </>}
                      {m?.usage &&
                      <span className='ai-chat-usage-text'>KI-Einheiten: {accounting.formatNumber(m?.usage?.aiCredits || 0, 2, '.', ',')}</span>}
                      {/* <Tooltip label={'Vorlesen'} zIndex={9999}>
                        <div style={{marginTop: '2px'}}>
                          {audioLoader === m?.id ?
                          <Loader variant='bars' size={16}/>
                          :
                          isAudioPlaying === m?.id ?
                            <PauseIcon className='ai-chat-voice-icon mt-0' onClick={()=> this.stopTTS()}/>
                              :
                            <VolumeUpIcon className='ai-chat-voice-icon' onClick={()=> this.playTTS(m?.text.replace(/<[^>]*>/g, ''), m?.id)}/>}
                        </div>
                      </Tooltip> */}
                      {/* <Tooltip label={'Drucken'} zIndex={9999}>
                        <div>
                          <PrintIcon className='print-ai-chat' onClick={()=> this.printChat(m?.text)}/>
                        </div>
                      </Tooltip> */}
                    </Group>
                    <Group style={{visibility: hover === `hover-${m?.id}-${i}` ? 'visible' : 'hidden', marginTop: '4px'}}>
                      <span className='ai-chat-time'>{moment(m?.timestamp).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') ? `heute (${moment(moment.utc(m?.timestamp).toDate()).local().format('LT')} Uhr)` : `${moment(m?.timestamp).format('DD.MM.YYYY')} (${moment(moment.utc(m?.timestamp).toDate()).local().format('LT')} Uhr)`}</span>
                    </Group>
                  </Group>}
                </Stack>
              </Group>
            </Stack>)
          })}
          {welcomeLoader && messages.length === 0 &&
          <Stack align={'flex-start'}>
            <Group justify={'left'} style={{marginBottom: '1rem'}}>
              <Loader size={'xs'} type={'dots'} color={'#5555FF'}/>
            </Group>
          </Stack>}
          {chatLoader && <Loader size={'xs'} type={'dots'} color={'#5555FF'}/>}
          </>}
        </div>
        {aiConsentGiven && showScrollToBottom &&
        <ActionIcon
          radius="xl"
          size="lg"
          variant="filled"
          color="#5555FF"
          onClick={() => this.scrollToBottom()}
          style={{ position: 'absolute', bottom: '16px', right: '24px', boxShadow: '0 2px 6px rgba(0,0,0,0.2)' }}
        >
          <KeyboardArrowDownIcon />
        </ActionIcon>}
        </div>
        <Stack style={{width: '100%'}}>
          {metadata &&
          <Group className='ask-ai-chat-meta-data' justify="space-between">
            {/* ... (Your existing metadata code is unchanged) ... */}
            <Group gap={10}>
              <KeyboardReturnIcon style={{ transform: "scaleX(-1)", color: '#13135c' }} />
              <TruncatedTextHandler text={metadata?.targeted_reply} className={'ask-ai-chat-meta-data-text'} maxWidth={parseInt(width) - 105} disableTooltip={true}/>
            </Group>
            <CloseIcon className='ask-ai-chat-meta-data-close-icon' onClick={()=> this.setState({metadata: null})}/>
          </Group>}

          {/* === UPDATED: Simplified Textarea === */}
          {/* The div is needed as the tooltip target: a disabled <textarea>
              fires no mouse events of its own, so a tooltip on the input
              itself would never open. Wrapping the whole control means the
              prompt field, the "..." menu and the send icon all show the same
              hint. Tooltip.Floating rather than Tooltip so the hint follows
              the pointer instead of sitting at a fixed spot above a control
              that fills the width of the panel. */}
          <Tooltip.Floating
            label={AI_CONSENT_REQUIRED_TOOLTIP}
            disabled={aiConsentGiven}
            position={'top'}
            multiline
            w={260}
            zIndex={9999}
            // Same lavender the chat's own bubbles use; the default dark
            // tooltip looked foreign inside the chat panel.
            styles={{tooltip: {backgroundColor: '#E3E3FC', color: '#000', fontSize: '12px', fontWeight: 400, fontFamily: 'Inter, sans-serif'}}}>
          <div style={{width: '100%'}}>
          <Textarea
            classNames={{input: 'ai-chat-modal-textarea-input', section: 'ai-chat-modal-textarea-icons-section'}}
            rightSectionWidth={isRecording ? 120 : transcribeLoader ? 190 : 80}
            disabled={!aiConsentGiven || isRecording || transcribeLoader}
            placeholder='Bitte geben Sie Ihre Anfrage hier ein.'
            autosize
            minRows={1}
            maxRows={3}
            onHeightChange={(h) => this.setState({textareaHeight: h})}
            rightSection={
              isRecording ? (
                LIVE_TRANSCRIPTION_ENABLED ? (
                  <InlineVoiceRecorder
                    accountId={this.props.accountId}
                    userId={this.props.profileData?.id}
                    propertyId={this.props.propertyId}
                    encryptedToken={this.props.profileData?.auth?.encryptedToken}
                    onPartialText={(text) => this.setState({input: text})}
                    onFinish={(text) => {
                      // Sends straight away rather than leaving it in the input for a second
                      // click — clicking stop is already the "I'm done" signal.
                      const trimmed = (text || '').trim();
                      this.setState({ isRecording: false, input: text }, () => {
                        if (trimmed) this.send();
                      });
                    }}
                    onCancel={() => this.setState({isRecording: false})}
                    onError={(detail) => { this.setState({isRecording: false}); this.handleVoiceRecorderError(detail); }}
                  />
                ) : (
                  <InlineAudioRecorder
                    onFinish={(file) => this.setState({isRecording: false}, () => this.uploadAudio(file))}
                    onCancel={() => this.setState({isRecording: false})}
                  />
                )
              ) : transcribeLoader ? (
                <Group wrap="nowrap" gap={5} align="flex-end" justify="center">
                  <Text className="ai-inline-voice-recorder-timer">Wird transkribiert</Text>
                  <Loader style={{paddingTop: '2px'}} size={'xs'} type='dots' color='#5555FF'/>
                </Group>
              ) : (
              <Group wrap="nowrap" gap={8} align='center' justify='center'>
                {fileUploadInProgress ?
                <Loader size={'sm'}/>
                :
                // The Indicator is no longer needed here as the visual is handled by the chip above
                <RecordOptions
                  disabled={!aiConsentGiven}
                  showEditButton={false}
                  showDeleteButton={false}
                  listOfItems={[
                      {
                        // Simplified: This button's text is now always the same
                        text: 'Datei anhängen',
                        disabled: !aiConsentGiven,
                        leftImage: <AttachFileIcon className={'ai-chat-modal-textarea-right-section-mic-icon'} />,
                        openFunction: this.triggerFileSelect
                      },
                      {
                        text: 'Aufnehmen',
                        disabled: !aiConsentGiven,
                        leftImage: <MicIcon className={'ai-chat-modal-textarea-right-section-mic-icon'}/>,
                        openFunction: (()=> aiConsentGiven && this.setState({isRecording: true}))
                      }//,
                      // {
                      //   content:
                      //   <Stack gap={2} style={{width: '230px', padding: '4px 16px 16px 16px'}}>
                      //     <Text size="xs" style={{fontSize: '14px'}}>Denkintensität</Text>
                      //     <Slider
                      //       size="sm"
                      //       color="#5555FF"
                      //       min={0}
                      //       max={reasoningEffortOptions.length - 1}
                      //       step={1}
                      //       styles={{markLabel: {fontSize: '11px', whiteSpace: 'nowrap'}}}
                      //       marks={reasoningEffortOptions.map((option, index) => ({value: index, label: reasoningEffortLabels[option]}))}
                      //       label={(value) => reasoningEffortLabels[reasoningEffortOptions[value]]}
                      //       value={reasoningEffortOptions.indexOf(reasoningEffort)}
                      //       onChange={(value) => this.setState({reasoningEffort: reasoningEffortOptions[value]})}
                      //     />
                      //   </Stack>
                      // }
                  ]}
                  style={{marginRight: '0px'}}
                  buttonStyle={{border: 'none', background: 'transparent'}}
                  menuStyle={{zIndex: 999999}}
                />
                }
                {!askCallInProgress ?
                  <SendIcon
                    style={{
                      cursor: (testCreditsExhausted || !aiConsentGiven) ? 'not-allowed' : 'pointer',
                      color: (testCreditsExhausted || !aiConsentGiven) ? '#9CA3AF' : '#5555FF',
                      fontSize: '18px',
                      opacity: (fileUploadInProgress || testCreditsExhausted || !aiConsentGiven) ? 0.6 : 1
                    }}
                    onClick={()=> aiConsentGiven && fileUploadInProgress === false && this.send()}/>
                  :
                  <StopIcon
                    style={{
                      cursor: 'pointer',
                      color: '#5555FF',
                      fontSize: '18px',
                      opacity: fileUploadInProgress ? 0.6 : 1
                    }}
                    onClick={()=> {
                      this.controller.abort();
                      this.setState({askCallInProgress: false});
                    }}
                  />
                }
              </Group>
              )
            }
            onPaste={this.handlePaste}
            value={this.state.input}
            onKeyDown={this.handleKeyDown}
            onChange={(event) => this.setState({ input: event.currentTarget.value })}
          />
          </div>
          </Tooltip.Floating>
          {selectedFiles.length > 0 &&
          <Group wrap="nowrap" style={{overflowX: 'scroll'}}>
            {selectedFiles.map((selectedFile, index) => 
            <Paper withBorder p="7px" radius="md" className="file-chip">
              <Group justify="space-between" wrap="nowrap">
                <Group gap="xs" wrap="nowrap">
                  <img src={this.returnFileIcon(selectedFile.file.type)} alt="file icon" style={{ width: '15px', height: '15px' }} />
                  {/* <Text size="sm">{selectedFile.file.name}</Text> */}
                  <TruncatedTextHandler text={selectedFile.file.name} maxWidth={200} />
                </Group>
                <ActionIcon 
                  size="xs" 
                  variant="transparent"
                  onClick={() => {
                    if(selectedFile.fileData.id){
                      this.handleDocumentDelete(null, selectedFile.fileData.id);
                    }
                  }}
                >
                  {selectedFile.fileData.id && <CloseIcon style={{ fontSize: '14px' }} />}
                </ActionIcon>
              </Group>
            </Paper>)}
          </Group>
          }
          <Group gap={0} style={{padding: '0px 6px'}}>
            <span className='ai-chat-notice'>Die KI kann Fehler machen. Bitte überprüfen Sie alle Informationen sorgfältig. Sie nutzen derzeit eine Beta-Version der KI. Die Angaben erfolgen ohne Gewähr. Bitte senden Sie uns Ihr <span className='intercom-chat-link' onClick={()=> window.Intercom('showNewMessage')}>Feedback zur hellohousing KI.</span></span>
          </Group>
          <input
            type="file"
            ref={this.fileInputRef}
            multiple
            // What the AI backend can read (attachmentReader.js there). Anything else would
            // only come back as "this file can't be read".
            accept=".pdf,.png,.jpg,.jpeg,.gif,.webp,.xlsx,.xlsm,.csv,.tsv,.txt,.json,.xml"
            disabled={!aiConsentGiven}
            style={{ display: 'none' }}
            onChange={this.handleFileChange}
          />
        </Stack>
      </Stack>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    accountData: state.generalReducer.accountData,
    propertySelected: state.generalReducer.property,
    aiMessages: state.generalReducer.aiMessages,
    aiChatSessionId: state.generalReducer.aiChatSessionId,
    aiChatSessionFolderId: state.generalReducer.aiChatSessionFolderId
  };
};
const action={
  setAiMessages,
  setAccountData,
  changeCurrentProperty
}
export default connect(mapStateToProps, action)(ChatApp)


{/* <Tooltip style={{width: '14px', height: '25px'}} label={<Group gap={5}><img src={selectedFile ? this.returnFileIcon(selectedFile?.type) : UploadIcon} style={{width: '12px', height: '14px'}}/><span>{selectedFile?.name}</span></Group>} zIndex={99999} disabled={!selectedFile}>
                {selectedFile && <CloseIcon onClick={()=> this.setState({selectedFile: null})} className='ai-chat-modal-close ai-chat-remove-file-button' style={{fontSize: '14px'}}/>}
                {selectedFile ?
                  <AttachFileIcon
                  style={{
                    cursor: 'pointer',
                    color: '#5555FF',
                    fontSize: '16px'
                  }}
                  onClick={this.triggerFileSelect}/>
                  :
                  <img src={UploadIcon} style={{width: '14px', height: '14px'}} onClick={this.triggerFileSelect}/>}
              </Tooltip>
              {transcribeLoader ?
              <Loader size={'xs'}/>
              :
              <MicIcon
              className={'ai-chat-modal-textarea-right-section-mic-icon'}
              onClick={()=> this.setState({openTranscribeModal: true})}/>} */}